import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import dataV from '@jiaminghi/data-view';
import $ from 'jquery';
//省市区
import VDistpicker from 'v-distpicker'
// 引入全局css
import './assets/scss/style.scss';
// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/icons/index'
//引入echart
//4.x 引用方式
import echarts from 'echarts';
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title
  next()
})
//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
//import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;

Vue.use(ElementUI);
// 全局注册
Vue.component('icon', Icon);
Vue.component('v-distpicker', VDistpicker);
Vue.use(dataV);
Vue.use($);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

